import {
  ASSIGN_USERS_AS_ADMIN_REQUEST,
  GET_ACCREDITATIONDROPDOWN_DETAILS,
  GET_ADMIN_INFO_DETAILS_REQUEST,
  GET_BASIC_INFO_DETAILS_REQUEST,
  GET_DEMOGRAPHIC_INFO_DETAILS_REQUEST,
  GET_DOCUMENT_INFO_DETAILS_REQUEST,
  GET_EMPLOYEE_FLOW_STAGING_REQUEST,
  GET_HOSTEL_INFO_DETAILS_REQUEST,
  GET_KEYSPECIALDROPDOWN_DETAILS,
  GET_OTHER_INFO_DETAILS_REQUEST,
  GET_OWNERSHIP_INFO_DETAILS_REQUEST,
  GET_OWNERSHIPTYPEDROPDOWN_DETAILS,
  GET_SOCIAL_INFO_DETAILS_REQUEST,
  SAVE_ADMIN_INFO_DETAILS_REQUEST,
  SAVE_BASIC_INFO_DETAILS_REQUEST,
  SAVE_BASIC_INFO_DETAILS_SUCCESS,
  SAVE_DEMOGRAPHIC_INFO_DETAILS_REQUEST,
  SAVE_DOCUMENT_INFO_DETAILS_REQUEST,
  SAVE_HOSTEL_INFO_DETAILS_REQUEST,
  SAVE_OTHER_INFO_DETAILS_REQUEST,
  SAVE_OWNERSHIP_INFO_DETAILS_REQUEST,
  SAVE_SOCIAL_INFO_DETAILS_REQUEST,
  SET_ADMIN_FACILITY,
  SET_EMPLOYEE_FLOW_STAGE,
  SET_EMPLOYEE_FLOW_STAGE_SUCCESS,
  SET_fLAG_AS_ADMIN_EMPLOYEE_FLOW_STAGING_REQUEST,
  SET_HOSTEL_FACILITY,
  SET_SKIP_STAGING_API,
  UPDATE_EMPLOYEE_FLOW_STAGING_REQUEST,
} from "./employeeFlow.type";

export const assignUserAsAdminRequest = (user, callback) => ({
  type: ASSIGN_USERS_AS_ADMIN_REQUEST,
  payload: { user },
  callback,
});

export const getBasicInfoDetailsRequest = (user, callback) => ({
  type: GET_BASIC_INFO_DETAILS_REQUEST,
  payload: { user },
  callback,
});

export const getEmployeeFlowStagingRequest = (user, callback) => ({
  type: GET_EMPLOYEE_FLOW_STAGING_REQUEST,
  payload: { user },
  callback,
});

export const saveBasicInfoRequest = (payload, callback) => ({
  type: SAVE_BASIC_INFO_DETAILS_REQUEST,
  payload,
  callback,
});

export const saveBasicInfoSuccess = (payload, callback) => ({
  type: SAVE_BASIC_INFO_DETAILS_SUCCESS,
  payload,
  callback,
});

export const updateEmployeeFlowStagingRequest = (user, stage, callback) => ({
  type: UPDATE_EMPLOYEE_FLOW_STAGING_REQUEST,
  payload: { user, stage },
  callback,
});
export const setFlowForSuperAdminFlowStagingRequest = (user, status, callback) => ({
  type: SET_fLAG_AS_ADMIN_EMPLOYEE_FLOW_STAGING_REQUEST,
  payload: { user, status },
  callback,
});

export const getAdminInfoDetailsgRequest = (user, callback) => ({
  type: GET_ADMIN_INFO_DETAILS_REQUEST,
  payload: { user },
  callback,
});

export const saveAdminInfoDetailsRequest = (payload, callback) => ({
  type: SAVE_ADMIN_INFO_DETAILS_REQUEST,
  payload,
  callback,
});
export const getDemographicDetailsgRequest = (user, callback) => ({
  type: GET_DEMOGRAPHIC_INFO_DETAILS_REQUEST,
  payload: { user },
  callback,
});

export const saveDemographicDetailsRequest = (payload, callback) => ({
  type: SAVE_DEMOGRAPHIC_INFO_DETAILS_REQUEST,
  payload,
  callback,
});

export const getOwnerShipDetailsgRequest = (user, callback) => ({
  type: GET_OWNERSHIP_INFO_DETAILS_REQUEST,
  payload: { user },
  callback,
});

export const saveOwnerShipDetailsRequest = (payload, callback) => ({
  type: SAVE_OWNERSHIP_INFO_DETAILS_REQUEST,
  payload,
  callback,
});

export const getDocumentDetailsgRequest = (user, callback) => ({
  type: GET_DOCUMENT_INFO_DETAILS_REQUEST,
  payload: { user },
  callback,
});

export const saveDocumentDetailsRequest = (payload, callback) => ({
  type: SAVE_DOCUMENT_INFO_DETAILS_REQUEST,
  payload,
  callback,
});

export const getOtherDetailsRequest = (user, callback) => ({
  type: GET_OTHER_INFO_DETAILS_REQUEST,
  payload: { user },
  callback,
});

export const saveOtherDetailsRequest = (payload, callback) => ({
  type: SAVE_OTHER_INFO_DETAILS_REQUEST,
  payload,
  callback,
});

export const getHostelDetailsRequest = (user, callback) => ({
  type: GET_HOSTEL_INFO_DETAILS_REQUEST,
  payload: { user },
  callback,
});


export const saveHostelDetailsRequest = (payload, callback) => ({
  type: SAVE_HOSTEL_INFO_DETAILS_REQUEST,
  payload,
  callback,
});

export const getOwnershipTypeDropdownRequest = (payload, callback) => ({
  type: GET_OWNERSHIPTYPEDROPDOWN_DETAILS,
  payload,
  callback,
});

export const getKeySpecialitiesDropdownRequest = (payload, callback) => ({
  type: GET_KEYSPECIALDROPDOWN_DETAILS,
  payload,
  callback,
});

export const getAccredDropdownRequest = (payload, callback) => ({
  type: GET_ACCREDITATIONDROPDOWN_DETAILS,
  payload,
  callback,
});

export const getSocialDetailsRequest = (user, callback) => ({
  type: GET_SOCIAL_INFO_DETAILS_REQUEST,
  payload: { user },
  callback,
});

export const saveSocialDetailsRequest = (payload, callback) => ({
  type: SAVE_SOCIAL_INFO_DETAILS_REQUEST,
  payload,
  callback,
});

// flow Start
export const setEmployeeFlowStage = (stage) => ({
  type: SET_EMPLOYEE_FLOW_STAGE,
  payload: stage,
});

export const setEmployeeFlowUiStage = (stage) => ({
  type: "SET_EMPLOYEE_FLOW_UI_STAGE",
  payload: stage,
});


export const setSkipStagingApi = (value) => ({
  type: SET_SKIP_STAGING_API,
  payload: value,
});

export const setEmployeeFlowSuccess = (payload, callback) => ({
  type: SET_EMPLOYEE_FLOW_STAGE_SUCCESS,
  payload,
  callback,
});
export const setHostelFacility = (value) => ({
  type: SET_HOSTEL_FACILITY,
  payload: value,
});

export const setAdminShowFacility = (value) => ({
  type: SET_ADMIN_FACILITY,
  payload: value,
});

export const setEmployeeFlowInitialized = () => ({
  type: "SET_EMPLOYEE_FLOW_INITIALIZED",
});

// flow End
